import { useContext } from 'react';

import { AuthContext } from 'state/auth';

export const useAuth = () => {
  return useContext(AuthContext);
};
